export default __webpack_public_path__ + "static/media/snapshot_alt.5516cab0.svg";